import React from 'react'

/**
 * FilterInput — the standard inline filter used by list surfaces
 * (TrackIndex, Job Queue, Turn-ins). Theme-var styled so it matches the
 * existing drawers without depending on desktop's ui/Input.
 */
export interface FilterInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Accessible label when no visible label is rendered. */
  'aria-label'?: string
}

export const FilterInput: React.FC<FilterInputProps> = ({ style, ...rest }) => (
  <input
    type="text"
    style={{
      width: '100%',
      padding: '8px 10px',
      borderRadius: '4px',
      border: '1px solid var(--border-color)',
      background: 'var(--hover-bg)',
      color: 'var(--text-primary)',
      fontSize: '13px',
      outline: 'none',
      ...style,
    }}
    {...rest}
  />
)

export default FilterInput
